import React, { useState } from "react";
import { Box, Button, Column, Columns, Control, Field, Input, Title } from "@allxsmith/bestax-bulma";
import WorkTotalsSection from "../WorkTotals/WorkTotalsSection";
import WorkTotals from "../WorkTotals/WorkTotals";
import Figure from "../Homepage/Figure";
import { Link } from "react-router-dom";
import {getStatus} from "../../utils";

function TopSummary({
  job,
  customer_label,
  customer2_label,
  quote,
  onSave,
  itemType,
  handleChange
}) {
  const items = job.work_items ? job.work_items : job.estimated_work_items;
  let filteredItems = items;
  // When looking at a quote the only work items that should be included in the top summary are ones that are being quoted to the customer
  if(quote && itemType === "Quote"){
    filteredItems = filteredItems.filter(item => item.added_after_quote === false);
  }

  const {status, approved} = getStatus(job, itemType)

  // TODO(bestax-migrate): Form.Label became a plain element; the Bulma helper prop(s) `invisible` were dropped — restyle with classes
  return (
    <Box className={"top-summary"}>
      <Columns isMultiline>
        {itemType === "Job" && quote && (
          <Column className="top-summary-section">
            <Title size="6">
              {customer2_label} Estimated Total (Full Quote)
            </Title>
            <Columns className="small-figure" isMultiline>
              <Figure
                label="Labour"
                loaded={true}
                value={job.full_quote_customer2_estimated_labour_total}
              />
            </Columns>
            <Columns className="small-figure" isMultiline>
              <Figure
                label="Parts"
                loaded={true}
                value={job.full_quote_customer2_estimated_parts_total}
              />
            </Columns>
              <Columns className="small-figure" isMultiline>
              <Figure
                label="Total"
                loaded={true}
                value={
                  job.full_quote_customer2_estimated_labour_total +
                  job.full_quote_customer2_estimated_parts_total
                }
              />
            </Columns>
          </Column>
        )}
        {itemType === "Job" && quote && (
          <Column className="top-summary-section">
            <Title size="6">
              {customer2_label} Actual Costs (Full Quote)
            </Title>
            <Columns className="small-figure" isMultiline>
              <Figure
                label="Labour"
                loaded={true}
                value={job.full_quote_customer2_actual_labour_total}
              />
            </Columns>
              <Columns className="small-figure" isMultiline>
              <Figure
                label="Parts"
                loaded={true}
                value={job.full_quote_customer2_actual_parts_total}
              />
            </Columns>
                <Columns className="small-figure" isMultiline>
              <Figure
                label="Total"
                loaded={true}
                value={
                  job.full_quote_customer2_actual_labour_total +
                  job.full_quote_customer2_actual_parts_total
                }
              />
            </Columns>
          </Column>
        )}
        {quote && (
          <Column className="top-summary-section">
            <Title size="6">Estimated Supplier Costs</Title>
            <WorkTotals
              workItems={items}
              allItems={true}
              labourFieldName="estimated_labour_cost"
              partFieldName="estimated_cost"
            />
          </Column>
        )}
        {quote && (
          <Column className="top-summary-section">
            <Title size="6">Estimated {customer_label} Total</Title>
            <WorkTotals
              workItems={filteredItems}
              allItems={false}
              chargeable={false}
              labourFieldName="estimated_customer_labour_cost"
              partFieldName="estimated_customer_cost"
            />
          </Column>
        )}
        {quote && (
          <Column className="top-summary-section">
            <Title size="6">Estimated {customer2_label} Total</Title>
            <WorkTotals
              workItems={filteredItems}
              allItems={false}
              chargeable={true}
              labourFieldName="estimated_customer_labour_cost"
              partFieldName="estimated_customer_cost"
            />
          </Column>
        )}
        <Column className="top-summary-section">
          <Title size="6">Total Supplier Costs</Title>
          <WorkTotals
            workItems={items}
            allItems={true}
            labourFieldName="labour_cost"
            partFieldName="cost"
          />
        </Column>
        <Column className="top-summary-section">
          <Title size="6">{customer_label} Total</Title>
          <WorkTotals
            workItems={filteredItems}
            allItems={false}
            chargeable={false}
            labourFieldName="customer_labour_cost"
            partFieldName="customer_cost"
          />
        </Column>
        <Column>
          <Title size="6">{customer2_label} Total</Title>
          <WorkTotals
            workItems={filteredItems}
            allItems={false}
            chargeable={true}
            labourFieldName="customer_labour_cost"
            partFieldName="customer_cost"
          />
        </Column>
        <Column>
          <Title size="6">Custom</Title>
          <Columns isMultiline>
            <Column>
              {itemType === "Quote" && <label className="label">BLANK</label>}
              <Input
                tabIndex={1}
                type="text"
                value={job.custom_label_1}
                name="custom_label_1"
                onChange={handleChange}
              />
            </Column>
            <Column>
              {itemType === "Quote" && <label className="label">Customer 1 Amount</label>}
              <Input
                tabIndex={2}
                type="text"
                value={job.custom_value_1}
                name="custom_value_1"
                onChange={handleChange}
              />
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              {itemType === "Quote" && <label className="label">BLANK</label>}
              <Input
                tabIndex={3}
                type="text"
                value={job.custom_label_2}
                name="custom_label_2"
                onChange={handleChange}
              />
            </Column>
            <Column>
              {itemType === "Quote" && <label className="label">Customer 2 Amount</label>}
              <Input
                tabIndex={4}
                type="text"
                value={job.custom_value_2}
                name="custom_value_2"
                onChange={handleChange}
              />
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              {itemType === "Quote" && <label className="label">BLANK</label>}
              <Input
                tabIndex={5}
                type="text"
                value={job.custom_label_3}
                name="custom_label_3"
                onChange={handleChange}
              />
            </Column>
            <Column>
              {itemType === "Quote" && <label className="label">BLANK</label>}
              <Input
                tabIndex={6}
                type="text"
                value={job.custom_value_3}
                name="custom_value_3"
                onChange={handleChange}
              />
            </Column>
          </Columns>
        </Column>
      </Columns>
      <Columns isMultiline>
        <Column>
          <Field>
            <label>Registration</label>
            <Control className="registration-wrapper">
              <Input
                className="registration-field"
                type="text"
                name="registration"
                value={job.vehicle ? job.vehicle.registration : ""}
                disabled
                readOnly
                required
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label>VIN Number</label>
            <Control>
              <Input
                type="text"
                name="vin_number"
                value={job.vehicle ? job.vehicle.vin_number : ""}
                readOnly
                disabled
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label>First Registration Date</label>
            <Control>
              <Input
                type="date"
                name="first_registration_date"
                value={job.vehicle ? job.vehicle.first_registration_date : ""}
                readOnly
                disabled
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label>{itemType} No.</label>
            <Input
              type="text"
              value={job.id || ""}
              readOnly
              disabled
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label>Workshop</label>
            <Input
              type="text"
              name="display_name"
              value={job.workshop ? job.workshop.display_name : ""}
              readOnly
              disabled
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label>{itemType} Status</label>
            <Input
              className="has-text-weight-bold"
              type="text"
              value={status}
              readOnly
              disabled
              data-testid={"job-status"}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <label>Creator</label>
            <Input
              className="has-text-weight-bold"
              type="text"
              value={job.creator ? job.creator.first_name + " " + job.creator.last_name : ""}
              readOnly
              disabled
              data-testid={"job-creator"}
            />
          </Field>
        </Column>
        {approved &&
        <Column>
          <label>Approved</label>
          <Field>
            <Input
                className="has-text-weight-bold"
                type="text"
                readOnly
                disabled
                value={"APPROVED"}
                data-testid={"summary-status"}
            >
            </Input>
          </Field>
        </Column>
        }
        {approved && job.approving_user &&
        <Column>
          <Field>
            <label>Approver</label>
            <Input
              className="has-text-weight-bold"
              type="text"
              value={`${job.approving_user.first_name} ${job.approving_user.last_name}` }
              readOnly
              disabled
            />
          </Field>
        </Column>
        }
        {itemType === "Job" && quote && (
          <Column>
            <Field>
              <Link to={`/editquote/${quote}`} target="_self">
                <Button tabIndex={-1} color="warning" className="is-pulled-right button-spacing">
                  Go To Quote
                </Button>
              </Link>
            </Field>
          </Column>
        )}
        {(itemType === "Quote" && quote && job.rental) &&(
          <Column>
            <Field>
              <Link to={`/editrental/${job.rental}`} target="_self">
                <Button tabIndex={-1} color="warning" className="is-pulled-right button-spacing">
                  Go To Rental
                </Button>
              </Link>
            </Field>
          </Column>
        )}
        <Column>
          <Field>
            <Button tabIndex={-1} onClick={onSave} color="info" className="is-pulled-left button-spacing">
              Save {itemType}
            </Button>
          </Field>
        </Column>
      </Columns>
    </Box>
  );
  // return <Box>
}

export default TopSummary;
